/**
 * Airwallex payment provider — card (recurring Billing) or Alipay (one-off prepaid).
 */

import type {
  PaymentProvider,
  PaymentMethod,
  InitPaymentParams,
  InitPaymentResult,
} from "../types";

const methods: PaymentMethod[] = [
  {
    id: "card",
    name: "Credit / Debit Card",
    region: "Auto-renew",
    recommended: true,
  },
  {
    id: "alipay",
    name: "Alipay",
    region: "HK / CN · Prepaid",
  },
];

export const airwallexPaymentProvider: PaymentProvider = {
  id: "airwallex",
  supportedMethods: methods,

  supportsMethod(methodId: string): boolean {
    return methods.some((m) => m.id === methodId);
  },

  async initPayment(params: InitPaymentParams): Promise<InitPaymentResult> {
    const paymentMethod =
      params.methodId === "alipay" ? "alipay" : "card";
    try {
      const res = await fetch("/api/checkout", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: params.email,
          planId: params.planId,
          paymentMethod,
        }),
      });

      const data = (await res.json()) as {
        error?: string;
        checkoutUrl?: string;
      };

      if (!res.ok) {
        return {
          success: false,
          error: data.error ?? "Payment setup failed",
        };
      }

      if (data.checkoutUrl) {
        return { success: true, redirectUrl: data.checkoutUrl };
      }

      return {
        success: false,
        error: data.error ?? "No checkout URL received",
      };
    } catch (err) {
      const message = err instanceof Error ? err.message : "Network error";
      return { success: false, error: message };
    }
  },
};
